class FixedHeader {
  constructor() {
    this.header = document.querySelector('.layout-container > header')
    this.violator = document.querySelector('.layout-container > .violator')
    this.fixed = false

    this.lastScrollTop = 0 // Initialize the variable to track the scroll direction

    this.setOffset()
    this.checkScrollLocation()

    window.onscroll = () => this.checkScrollLocation()
    window.onresize = () => this.setOffset()
  }

  setOffset() {
    this.offset = (this.violator) ? this.violator.clientHeight : 0
  }

  checkScrollLocation() {
    if (!this.fixed && window.pageYOffset >= this.offset) {
      this.fixed = true
      document.body.classList.add('sticky-header')
    } else if (this.fixed && window.pageYOffset < this.offset) {
      this.fixed = false
      document.body.classList.remove('sticky-header')
    }

    let currentScroll = window.pageYOffset || document.documentElement.scrollTop

    if (currentScroll > this.lastScrollTop) {
      this.header.classList.add('hidden')
    } else {
      this.header.classList.remove('hidden')
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll // Prevent negative scroll value
  }
}
export default FixedHeader
